import { Schema } from 'prosemirror-model';
import { EditorView } from 'prosemirror-view';

export function iframeSubmitCallback(
  attrMap,
  editorView,
  schema
) {
  const reUrlYoutube = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi;
  const reUrlVimeo = /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/|.*)/;
  const timeParamMatcher = /t=([^&]*)/;
  const hrefEnd = '?wmode=transparent';
  let src;
  let width;
  let height;
  let allow;
  let allowFullscreen;

  if (attrMap.src.match(reUrlYoutube) || attrMap.src.match(reUrlVimeo)) {
    src = attrMap.src;

    if (src.match(reUrlYoutube)) {
      src = src.replace(reUrlYoutube, '//www.youtube.com/embed/$1' + hrefEnd);
      if (attrMap.src.match(timeParamMatcher)) {
        src = src + `&start=${attrMap.src.match(timeParamMatcher)[1]}`;
      }
    } else if (src.match(reUrlVimeo)) {
      src = src.replace(reUrlVimeo, '//player.vimeo.com/video/$2' + '#wmode=transparent');
      if (attrMap.src.match(timeParamMatcher)) {
        src = src + `&${attrMap.src.match(timeParamMatcher)[0]}`;
      }
    }
  } else {
    const domparser = new DOMParser();
    const doc = domparser.parseFromString(attrMap.src, 'text/html');

    if (doc.body.children[0]) {
      src = (doc.body.children[0]).src;
      width = (doc.body.children[0]).width;
      height = (doc.body.children[0]).height;
      allowFullscreen = (doc.body.children[0]).allowFullscreen;
      allow = (doc.body.children[0]).allow;
    } else {
      editorView.dispatch(editorView.state.tr.setMeta('prompt-menu-plugin', ''));
      editorView.focus();
      return;
    }
  }

  editorView.dispatch(
    editorView.state.tr.replaceSelectionWith(
      schema.nodes.iframe.create({
        src,
        width,
        height,
        allow,
        allowFullscreen
      })
    )
  );
  editorView.dispatch(editorView.state.tr.setMeta('prompt-menu-plugin', ''));
  editorView.focus();
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/iframeSubmitCallback.js